import { gql } from '@apollo/client';

import { MINIMAL_USER_FIELDS_FRAGMENT } from './user';
import { FR_MACHINE_TYPE_FIELDS } from './machineType';
import { FR_POINT_FIELDS } from './point';

/* This is a duplicate from src/lib/apollo/fragments/location.ts, but can't be imported directly 
    due to an error: "Uncaught ReferenceError: Cannot access 'BASIC_LOCATION_FIELDS_FRAGMENT' before initialization"
*/
const BASIC_LOCATION_FIELDS_FRAGMENT = gql`
    fragment BasicLocationFields on Location {
        Name
        LocationId
        Point {
            ...fr_PointFields
        }
    }
    ${FR_POINT_FIELDS}
`;

export const FR_TASKTYPE_FIELDS = gql`
    fragment fr_TaskTypeFields on TaskType {
        TaskTypeId
        Name
        TaskGroup
        Abbr
        TaskTypeDetails {
            Origin
            Abbr
            Code
            Symbol
        }
    }
`;

export const BASIC_TASK_TYPE_FIELDS_FRAGMENT = gql`
    fragment BasicTaskTypeFields on TaskType {
        TaskTypeId
        Name
        TaskGroup
        Abbr
        TaskTypeDetails {
            Origin
            Abbr
            Code
            Symbol
        }
    }
`;

export const BASIC_TASK_PRIORITY_FIELDS_FRAGMENT = gql`
    fragment BasicTaskPriorityFields on TaskPriority {
        Name
        TaskPriorityId
        Updated
    }
`;

export const BASIC_TASK_RESOURCE_FIELDS_FRAGMENT = gql`
    fragment BasicTaskResourceFields on TaskResource {
        TaskResourceId
        Machine {
            MachineId
            Name
        }
    }
`;

export const BASIC_TASK_FIELDS_FRAGMENT = gql`
    fragment BasicTaskFields on Task {
        TaskId
        TaskStatus {
            TaskStatusId
            Name
        }
        StartDate
        EndDate
        PlannedStartDate
        PlannedEndDate
        Created
        Updated
        TaskType {
            ...BasicTaskTypeFields
        }
        TaskStatus {
            TaskStatusId
            Name
        }
    }
    ${BASIC_TASK_TYPE_FIELDS_FRAGMENT}
`;

export const TASK_FIELDS_WITH_STATUS_AND_TYPE_INFO = gql`
    fragment TaskFieldsWithStatusAndTypeInfo on Task {
        TaskId
        TaskTypeId
        PlannedStartDate
        PlannedEndDate
        StartDate
        EndDate
        Created
        Updated
        DepthStart
        DepthTotal
        DepthSoil
        DepthRock
        TimeDrill
        TimeRock
        TimeTotal
        TaskType {
            ...BasicTaskTypeFields
        }
        TaskStatus {
            TaskStatusId
            Name
        }
        TaskResource {
            Machine {
                MachineId
                Name
                SerialNbr
                MachineType {
                    ...fr_MachineTypeFields
                }
                MachineModel {
                    Name
                }
                Asset {
                    AssetType
                    AssetName
                }
            }
        }
        TaskEndReason {
            TaskEndReasonId
            Code
        }
        WorkPackage {
            WorkPackageId
        }
        Driller {
            ...MinimalUserFields
        }
        TaskPriority {
            ...BasicTaskPriorityFields
        }
    }
    ${FR_MACHINE_TYPE_FIELDS}
    ${BASIC_TASK_TYPE_FIELDS_FRAGMENT}
    ${MINIMAL_USER_FIELDS_FRAGMENT}
    ${BASIC_TASK_PRIORITY_FIELDS_FRAGMENT}
`;

export const TASK_FIELDS_WITH_STATUS_AND_TYPE_INFO_LIMITED = gql`
    fragment TaskFieldsWithStatusAndTypeInfoLimited on Task {
        TaskId
        TaskTypeId
        PlannedStartDate
        PlannedEndDate
        StartDate
        EndDate
        Created
        Updated
        DepthStart
        DepthTotal
        DepthSoil
        DepthRock
        TimeDrill @include(if: $WithTimeDrilled)
        TimeRock @include(if: $WithTimeDrilled)
        TimeTotal @include(if: $WithTimeDrilled)
        TaskType {
            ...BasicTaskTypeFields
        }
        TaskStatus {
            TaskStatusId
            Name
        }
        TaskResource {
            Machine {
                MachineId
                Name
                SerialNbr
                MachineType {
                    ...fr_MachineTypeFields
                }
                MachineModel {
                    Name
                }
                Asset {
                    AssetType
                    AssetName
                }
            }
        }
        TaskEndReason {
            TaskEndReasonId
            Code
        }
        WorkPackage {
            WorkPackageId
        }
        Driller {
            ...MinimalUserFields
        }
        TaskPriority {
            ...BasicTaskPriorityFields
        }
    }
    ${FR_MACHINE_TYPE_FIELDS}
    ${BASIC_TASK_TYPE_FIELDS_FRAGMENT}
    ${MINIMAL_USER_FIELDS_FRAGMENT}
    ${BASIC_TASK_PRIORITY_FIELDS_FRAGMENT}
`;

export const TASK_WITH_RESOURCED_FIELDS_FRAGMENT = gql`
    fragment TaskResourcedFields on Task {
        TaskId
        TaskStatus {
            TaskStatusId
            Name
        }
        StartDate
        EndDate
        PlannedStartDate
        PlannedEndDate
        TaskEndReason {
            Code
            Name
            TaskEndReasonId
        }
        Created
        Updated
        DepthRock
        DepthSoil
        DepthStart
        DepthTotal
        TimeDrill
        TimeRock
        TimeTotal
        TaskResource {
            ...BasicTaskResourceFields
        }
        TaskType {
            ...BasicTaskTypeFields
        }
        Location {
            ...BasicLocationFields
        }
    }
    ${BASIC_TASK_RESOURCE_FIELDS_FRAGMENT}
    ${BASIC_TASK_TYPE_FIELDS_FRAGMENT}
    ${BASIC_LOCATION_FIELDS_FRAGMENT}
`;

export const FR_TASK_FIELDS = gql`
    fragment fr_TaskFields on Task {
        TaskId
        TaskTypeId
        PlannedStartDate
        PlannedEndDate
        StartDate
        EndDate
        Created
        Updated
        DepthStart
        DepthTotal
        DepthSoil
        DepthRock
        TimeDrill
        TimeRock
        TimeTotal
    }
`;
